'use strict';
import Api from './Api';

export default class Model extends Api {

    static STATUS_ACTIVE = 1;
    static STATUS_DISABLED = 2;

    constructor (config = {}) {
        super();

        const relations = this.relations();
        for (let field in config) {
            if (Object.prototype.hasOwnProperty.call(config, field) === false) {
                continue;
            }
            let value = config[field];
            if (relations[field] && value) {
                if (relations[field].many === true) {
                    for (let index = 0; index < value.length; index++) {
                        value[index] = new relations[field].class(value[index]);
                    }
                } else {
                    value = new relations[field].class(value);
                }
            }
            this[`${field}`] = value;
        }
    }

    getValues() {
        let values = {};
        let relations = this.relations();
        const exceptFields = this.exceptFields();
        for (const [key, value] of Object.entries(this)) {
            if (relations[key] || exceptFields.indexOf(key) !== -1) {
                continue;
            }
            values[key] = value;
        }
        return values;
    }


    relations() {
        return {};
    }

    exceptFields() {
        return ['created_by', 'updated_by', 'created_at', 'updated_at'];
    }
}
